import { useState } from 'react';
import { UserAdd01Icon } from '@hugeicons/core-free-icons';
import { useAppSession } from '../../hooks/useAppSession';
import { capture } from '../../lib/analytics';
import { InviteTeamModal } from '../projects/InviteTeamModal';
import { Button } from '../ui/button';

/** Billing and its invitation both target useBillingInfo's active session team. */
/** `primary` right after a purchase that left seats free: inviting is the next step. */
export function BillingInviteButton({ disabled = false, variant = 'outline' }: { disabled?: boolean; variant?: 'outline' | 'primary' } = {}) {
  const { data: session } = useAppSession();
  const [openTeamId, setOpenTeamId] = useState<string | null>(null);
  const team = session?.team;
  if (!team || team.role !== 'owner') return null;

  return (
    <>
      <Button type="button" variant={variant} size="sm" icon={UserAdd01Icon}
        className="billing-plan-card__invite" aria-haspopup="dialog" disabled={disabled}
        onClick={() => { capture('invite_team_clicked', { source: 'billing_seats' }); setOpenTeamId(team.id); }}>
        Invite team
      </Button>
      {openTeamId === team.id && <InviteTeamModal key={team.id} teamId={team.id} source="billing_seats" onClose={() => setOpenTeamId(null)} />}
    </>
  );
}
